import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

import ValidatedPws from "../../../components/ValidatedInput/ValidatedPws/ValidatedPws";
import ButtonFotter from "../../../components/Button/ButtonFotter/ButtonFotter";
import OTPInput from "../../../components/TextInput/OtpInput/OtpInput";
import RecoverPwsOtpImg from "../../../assets/recoverPwsImage2.svg";
import Typography from "../../../components/Typography/Typography";
import Button from "../../../components/Button/Button";
import Loader from "../../../components/Loader/Loader";
import Modal from "../../../components/Modal/Modal";
import AuthPageShell from "../../../components/AuthPageShell/AuthPageShell";
import shellStyles from "../../../components/AuthPageShell/AuthPageShell.module.scss";
import styles from "./RecoverPwsOtp.module.scss";
import codes from "../../../utils/codes";

import { ReactComponent as ArrowLeft } from "../../../assets/arrowLeft.svg";
import { StateContext } from "../../../contexts/state.context";
import { changePasswordUser } from "../../../utils/services";

const RESEND_OTP_TIME = window.env.REACT_APP_RESEND_OTP_TIME;

const RecoverPwsOtp = () => {
	const navigate = useNavigate();
	const { formData } = useContext(StateContext);

	const [pws, setPws] = useState();
	const [pwsError, setPwsError] = useState();
	const [pwsStrength, setPwsStrength] = useState({
		hasLowerCase: false,
		hasUpperCase: false,
		hasNumber: false,
		hasSpecialChar: false,
		isLongEnough: false,
		isTooLong: false,
	});

	const [rePws, setRePws] = useState();
	const [rePwsError, setRePwsError] = useState();

	const [otp, setOtp] = useState();
	const [otpError, setOtpError] = useState();

	const [error, setError] = useState(false);
	const [errorMjs, setErrorMjs] = useState("Error");

	const [modal, setModal] = useState();
	const [loader, setLoader] = useState();

	const [secondsLeft, setSecondsLeft] = useState(RESEND_OTP_TIME);

	const handleBackClick = () => {
		navigate("/forgot-pws");
	};

	const handleResendLink = () => {
		if (secondsLeft === 0) return styles.recoverPwsOtpCardResendIsblue;
		else return styles.recoverPwsOtpCardResendIsNotblue;
	};

	const handleResendCode = () => {
		setSecondsLeft(RESEND_OTP_TIME);
	};

	const handlePwsChange = (password) => {
		setPws(password);
		setPwsStrength({
			hasLowerCase: /[a-z]/.test(password),
			hasUpperCase: /[A-Z]/.test(password),
			hasNumber: /\d/.test(password),
			hasSpecialChar: /[!@#$%^&*()_+={}[\]:;"'<>,.?/\\|`~-]/.test(
				password
			),
			isLongEnough: password.length >= 8,
			isTooLong: password.length <= 30,
		});
	};

	const isValidPws = (isValid) => {
		if (isValid) return styles.recoverPwsOtpItemValid;
		else return styles.recoverPwsOtpItemInvalid;
	};

	const validatePws = () => {
		const {
			hasLowerCase,
			hasNumber,
			hasSpecialChar,
			hasUpperCase,
			isLongEnough,
			isTooLong,
		} = pwsStrength;

		if (
			!hasLowerCase ||
			!hasNumber ||
			!hasSpecialChar ||
			!hasUpperCase ||
			!isLongEnough ||
			!isTooLong
		)
			return false;
		return true;
	};

	const handleBtnDisabled = () => {
		if (pws && rePws && otp) return false;
		else return true;
	};

	const handleSubmit = () => {
		if (!otp) {
			setOtpError(true);
			return;
		}

		if (otp.length < 6) {
			setOtpError(true);
			return;
		}

		if (!validatePws()) {
			setPwsError(true);
			return;
		}

		if (!rePws) {
			setRePwsError(true);
			return;
		}

		if (rePws !== pws) {
			setRePwsError(true);
			return;
		}

		const rData = {
			userIdentifier: formData.id,
			newPassword: pws,
			otp,
		};

		setLoader(true);

		changePasswordUser({ formInfo: rData })
			.then(({ code }) => {
				setLoader(false);

				switch (code) {
					case codes.JVB001.code:
						setModal(true);
						break;

					case codes.JVB010.code:
						setError(true);
						setErrorMjs(
							"La contraseña ingresada ya ha sido utilizada previamente. Por favor, ingrese una nueva."
						);
						break;

					default:
						setError(true);
						setErrorMjs(
							"Algo inesperado sucedió, intente nuevamente o contacte a soporte."
						);
						break;
				}
			})
			.catch((e) => {
				setLoader(false);
				setError(true);
				setErrorMjs(
					"Algo inesperado sucedió, intente nuevamente o contacte a soporte."
				);
				console.log(e);
			});
	};

	useEffect(() => {
		if (secondsLeft === 0) return;

		const interval = setInterval(() => {
			setSecondsLeft((prev) => prev - 1);
		}, 1000);

		return () => clearInterval(interval);
	}, [secondsLeft]);

	return (
		<>
			<AuthPageShell
				footer={
					<ButtonFotter
						onClick={handleSubmit}
						disabled={handleBtnDisabled()}
						dock="panel"
					>
						Cambiar contraseña
					</ButtonFotter>
				}
			>
				<div className={styles.recoverPwsOtpContainer}>
				<div className={shellStyles.authTitleContainer}>
					<ArrowLeft
						className={shellStyles.authTitleArrow}
						onClick={handleBackClick}
					></ArrowLeft>

					<div className={shellStyles.authTitleTxt}>
						<Typography variant="h5">
							Restablece tu contraseña
						</Typography>
					</div>
				</div>

				<div className={styles.recoverPwsOtpCard}>
				<img
					src={RecoverPwsOtpImg}
					alt="recover-pws-img"
					className={styles.recoverPwsOtpCardImg}
				></img>

				<div className={styles.recoverPwsOtpCardContent}>
					<Typography
						variant="h4"
						className={styles.recoverPwsOtpCardTitle}
					>
						Restablece tu contraseña
					</Typography>

					<Typography className={styles.recoverPwsOtpCardTxt}>
						Ingresa el código de seis dígitos que te enviamos y crea
						tu nueva contraseña.
					</Typography>

					<div className={styles.recoverPwsOtpCodeContainer}>
						<OTPInput
							error={otpError}
							onChange={(otp) => {
								setOtpError(false);
								setOtp(otp);
							}}
							type="text"
						></OTPInput>
						<Typography
							className={styles.recoverPwsOtpPwsOTPErrorMessage}
							color={otpError ? "primary" : "transparent"}
						>
							Código OTP inválido.
						</Typography>
					</div>

					<Typography
						className={styles.recoverPwsOtpCardResend}
						variant="p2"
					>
						Recuerda revisar la carpeta de{" "}
						<span style={{ fontWeight: "500" }}>Spam</span> o{" "}
						<span style={{ fontWeight: "500" }}>Promociones</span>.
						<br></br>
						¿No recibiste el código?{" "}
						<span
							className={handleResendLink()}
							onClick={handleResendCode}
						>
							Reenviar {secondsLeft > 0 ? secondsLeft : null}
						</span>
					</Typography>

					<ValidatedPws
						className={styles.recoverPwsOtpPwsInput}
						label="Contraseña nueva"
						placeholder="Escribe aquí tu contraseña"
						onChange={handlePwsChange}
						errorMessage="Contraseña inválida"
						error={pwsError}
						setError={setPwsError}
					></ValidatedPws>

					<div className={styles.recoverPwsOtpPwsValidations}>
						<ul className={styles.recoverPwsOtpList}>
							<li
								className={isValidPws(pwsStrength.hasLowerCase)}
							>
								Por lo menos una letra minúscula.
							</li>
							<li
								className={isValidPws(pwsStrength.hasUpperCase)}
							>
								Por lo menos una letra mayúscula.
							</li>
							<li className={isValidPws(pwsStrength.hasNumber)}>
								Por lo menos un número.
							</li>
							<li
								className={isValidPws(
									pwsStrength.hasSpecialChar
								)}
							>
								Por lo menos un caracter especial.
							</li>
							<li
								className={isValidPws(pwsStrength.isLongEnough)}
							>
								Mínimo 8 caracteres.
							</li>
						</ul>
					</div>

					<ValidatedPws
						className={styles.recoverPwsOtpPwsInput}
						label="Escríbe de nuevo tu contraseña"
						placeholder="Escribe aquí tu contraseña"
						errorMessage="Las contraseñas no coinciden"
						onChange={setRePws}
						error={rePwsError}
						setError={setRePwsError}
					></ValidatedPws>

					<Typography color={error ? "red" : "transparent"}>
						{errorMjs}
					</Typography>
				</div>
				</div>
				</div>
			</AuthPageShell>

			{modal && (
				<Modal title="¡Contraseña cambiada!" isSuccess>
					<>
						<Typography className={styles.recoverPwsOtpModalTxt}>
							Tu contraseña ha sido actualizada. Ya puedes{" "}
							<span style={{ fontWeight: "500" }}>
								iniciar sesión
							</span>{" "}
							de forma segura.
						</Typography>
						<Button
							className={styles.recoverPwsOtpModalBtn}
							onClick={() => navigate("/login")}
						>
							Iniciar sesión
						</Button>
					</>
				</Modal>
			)}

			{loader && <Loader />}
		</>
	);
};

export default RecoverPwsOtp;
